import ajax from "@/libs/Ajax";

let NAME_SPACE = '/sys/file';
export default {
  /**
   * 加载文件数据
   * @param params 查询参数
   */
  list(params) {
    return ajax.get(`${NAME_SPACE}/list`, {params: params});
  },
  /**
   * 删除
   * @param {String} uuid
   */
  delete(uuid) {
    return ajax.delete(`${NAME_SPACE}/delete`, {params: {uuid: uuid}});
  },

  /**
   * 删除
   * @param {String} uuid
   */
  download(uuid) {
    return ajax.get(`${NAME_SPACE}/download`, {params: {uuid: uuid,agile:true,down:true}});
  },

  /**
   * 保存文件
   * @param {String} uuid
   */
  save(uuid) {
    return ajax.delete(`${NAME_SPACE}/save`, {params: {uuid: uuid}});
  },
  /**
   * 生效一批数据
   * @param {String} uuid
   */
  saveAll(uuid) {
    return ajax.delete(`${NAME_SPACE}/saveAll`, {params: {uuid: uuid}});
  }
};
